import React from 'react';
import {
  Filter,
  Edit,
  SimpleForm,
  List,
  Create,
  Datagrid,
  FunctionField,
  TextInput,
  TextField,
  EditButton,
  CheckboxGroupInput,
  ReferenceInput,
  BooleanInput,
} from 'react-admin';

import ArrayChipField from './ui/ArrayChipField';

const UsersFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);

export const UsersList = props => (
  <List title="Users" {...props} bulkActionButtons={false} filters={<UsersFilter />}>
    <Datagrid>
      <TextField source="id" sortable={false} />
      <TextField source="email" />
      <TextField source="username" />
      <FunctionField
        sortable={false}
        source="firstName"
        label="Full Name"
        render={(record, source) => {
          return (
            <div>
              {record[source]} {record['lastName']}
            </div>
          );
        }}
      />
      <ArrayChipField source="roles" sortable={false} />
      <ArrayChipField source="languages" sortable={false} />
      <EditButton />
    </Datagrid>
  </List>
);

export const UserEdit = props => (
  <Edit title="User" {...props}>
    <SimpleForm>
      <TextInput source="email" />
      <TextInput source="username" />
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <TextInput source="password" type="password" />

      <ReferenceInput label="Roles" source="roles" reference="config/roles" allowEmpty>
        <CheckboxGroupInput source="id" allowEmpty={true} />
      </ReferenceInput>

      <ReferenceInput label="Languages" source="languages" reference="config/languages" allowEmpty>
        <CheckboxGroupInput source="id" allowEmpty={true} />
      </ReferenceInput>

      <BooleanInput label="Receive daily sources report" source="daily_report" style={{width: '100%'}} />
      <BooleanInput label="Receive weekly sources report" source="weekly_report" style={{width: '100%'}} />
      <BooleanInput label="Receive alerts" source="alerts" />
    </SimpleForm>
  </Edit>
);

export const UserCreate = props => (
  <Create title="Create User" {...props}>
    <SimpleForm>
      <TextInput source="email" />
      <TextInput source="username" />
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <TextInput source="password" type="password" />

      <ReferenceInput label="Roles" source="roles" reference="config/roles" allowEmpty>
        <CheckboxGroupInput source="id" allowEmpty={true} />
      </ReferenceInput>

      <ReferenceInput label="Languages" source="languages" reference="config/languages" allowEmpty>
        <CheckboxGroupInput source="id" allowEmpty={true} />
      </ReferenceInput>

      <BooleanInput label="Receive daily sources report" source="daily_report" style={{width: '100%'}} />
      <BooleanInput label="Receive weekly sources report" source="weekly_report" style={{width: '100%'}} />
      <BooleanInput label="Receive alerts" source="alerts" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/users.js